var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.list.length > 0)?_c('div',{staticClass:"share-wrap"},_vm._l((_vm.list),function(iten,idx){return _c('div',{key:idx,staticClass:"share-item",on:{"click":function($event){return _vm.goShare(iten)}}},[_c('img',{staticClass:"facebook",attrs:{"src":iten.cover_url,"alt":""}})])}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }